import React from 'react';
import ImageItem from './imageItem';

type TImagesProps = {
  images: Array<IUploadImage>;
  setFile: React.Dispatch<React.SetStateAction<IUploadImage[]>>;
  setOldImages?: React.Dispatch<React.SetStateAction<IOldImage[]>>;
};
const Images = ({images, setFile, setOldImages}: TImagesProps) => {
  return (
    <>
      <div className="flex justify-between mt-4">
        <span className="text-gray-6"> تصاویر بارگزاری شده</span>
        <small className="text-gray-6">تصویر اصلی آگهی</small>
      </div>
      {React.Children.toArray(
        images?.map(item => (
          <ImageItem
            setOldImages={setOldImages}
            image={item}
            setFile={setFile}
          />
        )),
      )}
    </>
  );
};

export default Images;
